import styled from 'styled-components'

import { DrawerLabel } from 'src/components'

export const Container = styled.div`
  flex: 1;
`

export const Group = styled.div`
  padding-top: 1.2rem;
  margin-bottom: 1.6rem;
`

export const GroupLabel = styled(DrawerLabel)`
  margin-bottom: 1.2rem;
`
